import React from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import { Link as RouterLink } from "react-router-dom";
import { Brightness4, Brightness7 } from "@mui/icons-material";
import { useTheme } from "../../ThemeContext";
import { TRANSPARENT_BLACK_08 } from "../../constants";

function Navbar() {
  const { darkMode, toggleTheme } = useTheme();

  return (
    <AppBar position="static" color="transparent" elevation={0} sx={{ mb: 4 }}>
      <Toolbar>
        <Typography variant="h6" sx={{ flexGrow: 1, fontWeight: 700 }}>
          San Diego Gaming
        </Typography>
        
        <Button 
          color="inherit" 
          component={RouterLink} 
          to="/"
          sx={{ 
            fontWeight: 600,
            fontSize: "1rem",
            textTransform: "none",
            "&:hover": {
              backgroundColor: TRANSPARENT_BLACK_08
            }
          }}
        >
          Home
        </Button>
        <Button 
          color="inherit" 
          component={RouterLink} 
          to="/clubs"
          sx={{ 
            fontWeight: 600,
            fontSize: "1rem",
            textTransform: "none",
            "&:hover": {
              backgroundColor: TRANSPARENT_BLACK_08
            }
          }}
        >
          Browse Clubs
        </Button>
        <Button 
          color="inherit" 
          component={RouterLink} 
          to="/create-club"
          sx={{ 
            fontWeight: 600,
            fontSize: "1rem",
            textTransform: "none",
            "&:hover": {
              backgroundColor: TRANSPARENT_BLACK_08
            }
          }}
        >
          Create Club
        </Button>
        <Button 
          color="inherit" 
          component={RouterLink} 
          to="/merch"
          sx={{ 
            fontWeight: 600,
            fontSize: "1rem",
            textTransform: "none",
            "&:hover": {
              backgroundColor: TRANSPARENT_BLACK_08
            }
          }}
        >
          Merch
        </Button>
        <Button 
          color="inherit" 
          component={RouterLink} 
          to="/sponsor"
          sx={{ 
            fontWeight: 600,
            fontSize: "1rem",
            textTransform: "none",
            "&:hover": {
              backgroundColor: TRANSPARENT_BLACK_08
            }
          }}
        >
          Sponsor
        </Button>
        
        <IconButton
          onClick={toggleTheme}
          color="inherit" 
          sx={{ ml: 1 }}
          title={darkMode ? "Switch to light mode" : "Switch to dark mode"}
          aria-label={darkMode ? "Switch to light mode" : "Switch to dark mode"}
        >
          {darkMode ? <Brightness7 /> : <Brightness4 />}
        </IconButton>
      </Toolbar>
    </AppBar>
  );
}

export default Navbar; 